import type { ReactNode } from "react";

import { HaNSearchContext } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";

import { HaNSearchResults } from "../../search/HaNSearchResults";
import { HaNErrorBoundary } from "../../shared/HaNErrorBoundary";

export const HaNList = ({ children }: { children: ReactNode }) => {
  const { isSearching } = useRequiredContext(HaNSearchContext);

  return (
    <div className="relative col-start-1 row-start-4 flex min-h-0 flex-col overflow-y-auto border-r bg-white max-sm:row-start-5 max-sm:border-r-0 max-sm:group-data-[map-list-view=map]/han:hidden">
      <HaNErrorBoundary area="List">{isSearching ? <HaNSearchResults /> : children}</HaNErrorBoundary>
    </div>
  );
};
